"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _IPC = _interopRequireDefault(require("@/libs/IPC"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var firstRun = true;
var _default = {
  data: function data() {
    return {
      hasOtherTab: false,
      addedNetworkToExisting: false,
      server: null,
      readyToShowOptions: false
    };
  },
  computed: {
    networks: function networks() {
      return this.$state.networks;
    },
    hasFragment: function hasFragment() {
      return window.location.hash && window.location.hash.length > 1;
    }
  },
  created: function created() {
    var _this = this;
    this.$state.setting('allowRegisterProtocolHandler', true);

    // Enable IPC listeners
    // This is used to allow opening new servers in existing tab
    _IPC.default.init();
    var server = null;
    if (this.hasFragment) {
      server = this.parseFragment();
      this.server = server;
    }
    if (server) {
      this.findOtherTabs().then(function (hasOtherTab) {
        if (hasOtherTab) {
          _this.hasOtherTab = true;
          // Don't start the main kiwi app here as it's already open elsewhere
        } else {
          _this.listenForOtherTabs();
          _this.init();
        }
        _this.readyToShowOptions = true;
      });
    } else {
      this.listenForOtherTabs();
      this.init();
    }
  },
  methods: {
    listenForOtherTabs: function listenForOtherTabs() {
      var _this2 = this;
      _IPC.default.on('message', function (e) {
        // respond to other tabs that are looking
        var msg = e.data;
        if (msg.type === 'ping' && _this2.networks.length > 0) {
          _IPC.default.send({
            type: 'pong'
          });
        } else if (msg.type === 'addNetwork') {
          var _context;
          var network = (0, _find.default)(_context = _this2.networks).call(_context, function (n) {
            return n.name === msg.server;
          });
          if (!network) {
            network = _this2.$state.addNetwork(msg.server, msg.nick || 'Guest' + Math.floor(Math.random() * 100), msg);
          }
          network.showServerBuffer('settings');
        }
      });
    },
    addEmptyNetwork: function addEmptyNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    findOtherTabs: function findOtherTabs() {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _promise.default(function (resolve, reject) {
                var handleIPCMessage = function handleIPCMessage(e) {
                  var msg = e.data;
                  if (msg.type === 'pong') {
                    clearTimeout(timer);
                    resolve(true);
                  }
                };
                var timer = setTimeout(function (e) {
                  _IPC.default.removeListener('message', handleIPCMessage);
                  resolve(false);
                }, 200);
                _IPC.default.on('message', handleIPCMessage);
                _IPC.default.send({
                  type: 'ping'
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee);
      }))();
    },
    addNetworkToExistingTab: function addNetworkToExistingTab() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var con = this.server;
      this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      _IPC.default.send({
        nick: nick,
        server: con.server,
        port: con.port,
        tls: con.tls,
        direct: con.direct,
        password: con.password || '',
        type: 'addNetwork'
      });
      window.location.hash = '';
      this.addedNetworkToExisting = true;
    },
    addNetwork: function addNetwork() {
      var temporary = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.server) {
        return;
      }
      var con = this.server;
      if (temporary) {
        this.$state.persistence.storageKey = null;
        this.$state.persistence.forgetState();
        this.init();
      }
      var network = this.$state.getNetworkFromAddress(con.server);
      if (!network) {
        network = this.$state.addNetwork(con.server, con.nick || 'Guest' + Math.floor(Math.random() * 100), {
          server: con.server,
          port: con.port,
          tls: con.tls,
          direct: con.direct,
          password: con.password || ''
        });
      }
      window.location.hash = '';
      network.showServerBuffer('settings');
      this.$emit('start', {
        fallbackComponent: this.constructor
      });
    },
    parseFragment: function parseFragment() {
      if (window.location.hash.substr(1)) {
        var fragment = window.location.hash.substr(1);

        // Check to see if we're dealing with an encoded irc: uri (browsers do this
        // when clicking an IRC link)
        var uriCheck = fragment.substr(0, 7).toLowerCase();
        if (uriCheck === 'ircs%3a' || uriCheck.substr(0, 6) === 'irc%3a') {
          fragment = decodeURIComponent(fragment);
        }
        var connections = Misc.parseIrcUri(fragment);
        var con = connections[0];
        return con;
      }
      return null;
    },
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    init: function init() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var persistSetting, _context3, controllerNet, bouncer;
        return _regenerator.default.wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (firstRun) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              firstRun = false;

              // persist the buffers in the state by default
              persistSetting = _this3.$state.settings.startupOptions.remember_buffers;
              if (typeof persistSetting === 'undefined') {
                _this3.$state.persistence.includeBuffers = true;
              } else {
                _this3.$state.persistence.includeBuffers = !!persistSetting;
              }
              _this3.$state.persistence.watchStateForChanges();
              if (_this3.$state.settings.startupOptions.bouncer) {
                controllerNet = (0, _find.default)(_context3 = _this3.$state.networks).call(_context3, function (n) {
                  return n.is_bnc;
                });
                if (controllerNet) {
                  bouncer = new _BouncerProvider.default(_this3.$state);
                  bouncer.enable(controllerNet.connection.server, controllerNet.connection.port, controllerNet.connection.tls, controllerNet.connection.direct, controllerNet.connection.path);
                }
              }
              // force restricted: false as users need access
              // to network settings to add a network
              _this3.$state.setSetting('settings.restricted', false);
              if (_this3.$state.networks.length) {
                // small screen devices cannot open the statebrowser unless a network is selected
                // if any network exists in saved config make that active on startup
                _this3.$state.setActiveBuffer(_this3.$state.networks[0].id, '*');
              }
              _this3.$emit('start', {
                fallbackComponent: _this3.constructor
              });
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee2);
      }))();
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Personal"]
window._kiwi_exports.components.startups.Personal = exports.default ? exports.default : exports;
